<template>
  <el-dialog
    :title="'选择所属库房'"
    :visible.sync="open"
    :center="true"
    width="513px"
    @close="cancel"
    :close-on-click-modal="false"
  >
    <div>
      <el-input
        v-model="keyWord"
        suffix-icon="el-icon-search"
        @change="inputChange"
        placeholder="输入关键字搜索"
      ></el-input>
    </div>
    <div class="select-dialog">
      <div class="left-div width100">
        <el-checkbox-group
          v-model="checked"
          @change="change"
          class="checkbox-item"
        >
          <el-checkbox v-for="item in data" :label="item.id" :key="item.id">{{
            item.no + " " + item.name
          }}</el-checkbox>
        </el-checkbox-group>
        <!-- <el-tree :data="data" :props="defaultProps" show-checkbox @check-change="handleNodeClick" accordion node-key="id" :render-content="renderContent"></el-tree> -->
      </div>
    </div>
    <div class="selected-div">
      <template v-for="item in checkedDatas">
        <div :key="item.id" class="value">
          <span
            >{{ item.no + " " + item.name + " " }}
            <i
              class="el-icon-close"
              style="cursor: pointer;"
              
              v-preventReClick
            @click="removeItem(item)"
            />
          </span>
        </div>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn" size="small"  v-preventReClick
            @click="cancel"
        >取 消</el-button
      >
      <el-button
        class="btn primary"
        type="primary"
        size="small"
        
        v-preventReClick
            @click="submit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "myCheckBox",
  data() {
    return {
      checked: [],
      checkedDatas: [],
      open: false,
      keyWord: "",
    };
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    oldDatas: {
      type: Array,
      default() {
        return [];
      },
    },
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  watch: {
    show(val, oldVal) {
      this.open = val;
      // console.log(this.oldDatas)
      this.checked = this.oldDatas.map((e) => e.id);
      // console.log(this.checked)
      this.checkedDatas = JSON.parse(JSON.stringify(this.oldDatas));
    },
  },
  methods: {
    // handleNodeClick (node, state) {
    //   if (state) {
    //     this.rightData.push(node)
    //   }
    //   else {
    //     this.rightData = this.rightData.filter(i => i.id != node.id)
    //   }
    // },
    change(val) {
      if (val && val.length > 0) {
        let isAdd = false;
        // let changeId = null

        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          let item = this.checkedDatas.find((e) => e.id == val[i]);
          if (item == null) {
            isAdd = true;
            // changeId = val[i]
            let obj = this.data.find((e) => e.id == val[i]);
            if (obj) {
              this.checkedDatas.push(obj);
            }
            break;
          }
        }

        console.log(this.checkedDatas, "this.checkedDatas");

        // 删除
        if (!isAdd) {
          this.checkedDatas = this.checkedDatas.filter(
            (i) => val.indexOf(i.id) != -1
          );
          // for (let i = 0; i < this.checkedDatas.length; i++) {
          //   let item = val.filter(e => e == this.checkedDatas[i].id)
          //   if(item == null){
          //     changeId = this.checkedDatas[i].id

          //     break;
          //   }
          // }
        }
      } else {
        this.checkedDatas = [];
      }
    },
    cancel() {
      this.open = false;
      this.checked = [];
      this.$emit("close");
    },
    submit() {
      this.open = false;
      this.$emit("getData", this.checkedDatas);
    },
    removeItem(data) {
      this.checkedDatas = this.checkedDatas.filter((i) => i.id != data.id);
      this.checked = this.checked.filter((i) => i != data.id);
    },
    inputChange(val) {
      this.$emit("filterMethod", val);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
</style>
